class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.headerSearch = this.closest('.header-search');
    this.searchFilterModal = document.querySelector('.search-filter-modal');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.MainPredictiveSearchResults =
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.searchHistory = 'searchHistory';

    this.setupEventListeners();

    // Bind Search Tags to Input
    this.bindSearchFilterToInput();
    this.initSearchIconPress();
    this.initSuggestionsLogic();

    this.updatePDPlink();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    this.addEventListener('input', this.onInput.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  normalizeSearchTerm(searchTerm) {
    return searchTerm.trim().toLowerCase();
  }

  getSearchPageUrl(searchTerm) {
    const normalizedSearchTerm = this.normalizeSearchTerm(searchTerm);
    const params = new URLSearchParams({
      q: normalizedSearchTerm,
      'options[prefix]': 'last',
      'options[unavailable_products]': 'show',
    });
    return `/search?${params.toString()}`;
  }

  onChange(e) {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      // this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;
    this.updateSuggestionsVisibility();

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    //check if new search differs from old
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);
    const oldSearchValue = params.get("q");

    if (this.searchTerm != oldSearchValue) {
      if (e?.detail?.source == 'search_button_filters') {
        if (window.location.href.includes('/search')) {
          this.classList.remove('suggestions-shown');
          this.getSearchResults(this.searchTerm);
        } else {
          window.location.href = this.getSearchPageUrl(this.searchTerm);
        }
      }
      else {
        if (!window.location.href.includes('/search')) {
          if (this.searchTerm.length >= 3) {
            this.getSearchSuggestions(this.searchTerm);
          }
        } else {
          if (this.searchTerm.length >= 3) {
            this.getSearchSuggestions(this.searchTerm);
          }
        }
      }

      if (this.id == 'predictive-search__header') {
        if (this.searchTerm <= 4) {
          this.filterButtonFilters();
        }
      }
    }
  }

  updateSuggestionsVisibility() {
    if (this.getQuery().length >= 3) {
      this.classList.add('suggestions-shown');
    } else {
      this.classList.remove('suggestions-shown');
    }
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
      event.preventDefault();
      return;
    }

    if (window.location.href.includes('/search')) {
      // avoid full page reload, render in place
      event.preventDefault();
      this.classList.remove('suggestions-shown');
      this.getSearchResults(this.getQuery());
    }
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);

      // If we're on the search results page and the main predictive search box is being reset, update the results via AJAX instead of a full page reload.
      // update results via AJAX instead of reloading
      if (this.id === 'predictive-search_main' && window.location.href.includes('/search')) {
        this.input.blur(); // don't leave it focused after reset
        this.resetSearchPageResults();
      }
    }
  }

  resetSearchPageResults() {
    const url = new URL(window.location);
    url.search = '';

    window.history.pushState({}, '', url);

    fetch(url.pathname, { signal: this.abortController.signal })
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        try {
          const freshResults = new DOMParser().parseFromString(text, 'text/html').querySelector('#search-results');
          const currentResults = this.querySelector('#search-results');

          if (freshResults && currentResults) {
            currentResults.replaceWith(freshResults);
            this.removeAttribute('results');
            initializeCustomTabs();
            freshResults.querySelectorAll('.search-filters__list').forEach((searchFilter) => {
              searchFilter.addEventListener('click', (event) => {
                const filterItem = event.target.closest('.search-filters__item');
                if (filterItem) this.handleFilterItemClick(event.target);
              });
            });
            if (typeof yotpoWidgetsContainer !== 'undefined' && typeof yotpoWidgetsContainer.initWidgets === 'function') {
              yotpoWidgetsContainer.initWidgets();
            }
          }
        } catch (renderError) {
          // don't let a render bug fall into the catch below and reload the page
          console.error('resetSearchPageResults: failed to render results', renderError);
        }
      })
      .catch((error) => {
        if (error?.code === 20) return;
        window.location.href = url.toString(); // fetch actually failed, reload as last resort
      });
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
    }
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown' || event.key === "Enter") {
      event.preventDefault();

      if (event.key === "Enter" && event.target.value.length >= 3) {
        const inputValue = event.target.value;

        if (this.id === 'predictive-search_main') {
          this.classList.remove('suggestions-shown');
        }

        if (window.location.href.includes('/search')) {
          this.getSearchResults(inputValue);
        }
        else {
          // do rerouting search
          window.location.href = this.getSearchPageUrl(inputValue);
        }
      }
    }
  }

  initSearchIconPress() {
    const searchIconButton = this.querySelector('.search__button');
    searchIconButton.addEventListener('click', (e) => {
      e.preventDefault(); // stop native submit, button type is submit
      const inputValue = this.input.value;

      if (window.location.href.includes('/search')) {
        // do rerendering search
        this.getSearchResults(inputValue);
      }
      else {
        // do rerouting search
        window.location.href = this.getSearchPageUrl(inputValue);
      }
    })
  }

  onInput() {
    if (this.classList.contains('search_suggestion_selected')) {
      this.classList.remove('search_suggestion_selected');
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchSuggestions(searchTerm) {
    const normalizedSearchTerm = this.normalizeSearchTerm(searchTerm);

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(normalizedSearchTerm)}&resources[limit]=20&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,tag,vendor&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const suggestionsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search .predictive-search__suggestions')?.outerHTML;

        if (suggestionsMarkup) {
          this.renderSearchSuggestions(suggestionsMarkup);
        }
      })
      .catch((error) => {
        if (error?.code === 20) {
          return;
        }
        this.close();
        throw error;
      });
  }

  getSearchResults(searchTerm) {
    if (window.location.href.includes('/search')) {
      // use real search results instead of predictive search's, so they match on reload
      this.fetchMainSearchResults(searchTerm);
      return;
    }

    const normalizedSearchTerm = this.normalizeSearchTerm(searchTerm);

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(normalizedSearchTerm)}&resources[limit]=20&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,tag,vendor&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        if (this.id == 'predictive-search__header') {
          const resultsSuggestionsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search .predictive-search__suggestions')?.innerHTML;

          if (resultsSuggestionsMarkup) {
            this.renderSearchResults(resultsSuggestionsMarkup);
          }
        }
      })
      .catch((error) => {
        if (error?.code === 20) {
          return;
        }
        this.close();
        throw error;
      });
  }

  fetchMainSearchResults(searchTerm) {
    const normalizedSearchTerm = this.normalizeSearchTerm(searchTerm);
    const mainInstance = document.querySelector('#predictive-search_main');
    if (!mainInstance) return;

    const url = new URL(window.location);
    url.searchParams.set('q', normalizedSearchTerm);
    url.searchParams.set('options[unavailable_products]', 'show');
    url.searchParams.set('options[prefix]', 'last');

    window.history.pushState({}, '', url);

    mainInstance.input.value = normalizedSearchTerm;
    if (this !== mainInstance) this.input.value = normalizedSearchTerm; // header box triggered it

    mainInstance.setLiveRegionLoadingState();

    fetch(url, { signal: this.abortController.signal })
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        try {
          const freshResults = new DOMParser().parseFromString(text, 'text/html').querySelector('#search-results');
          const currentResults = mainInstance.querySelector('#search-results');

          if (freshResults && currentResults) {
            currentResults.replaceWith(freshResults);
            mainInstance.setAttribute('results', true);
            mainInstance.removeAttribute('loading');
            initializeCustomTabs();
            freshResults.querySelectorAll('.search-filters__list').forEach((searchFilter) => {
              searchFilter.addEventListener('click', (event) => {
                const filterItem = event.target.closest('.search-filters__item');
                if (filterItem) mainInstance.handleFilterItemClick(event.target);
              });
            });
            if (typeof yotpoWidgetsContainer !== 'undefined' && typeof yotpoWidgetsContainer.initWidgets === 'function') {
              yotpoWidgetsContainer.initWidgets();
            }
            showDynamicPrices();
            mainInstance.updatePDPlink();
          }

          if (this.id === 'predictive-search__header') {
            document.body.classList.remove('overflow-hidden');
            document.querySelector('.header__search details')?.removeAttribute('open');
          }
        } catch (renderError) {
          // don't let a render bug fall into the catch below and reload the page
          mainInstance.removeAttribute('loading');
          console.error('fetchMainSearchResults: failed to render results', renderError);
        }
      })
      .catch((error) => {
        if (error?.code === 20) return;
        window.location.href = url.toString(); // fetch actually failed, reload as last resort
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    if (this.statusElement) {
      this.statusElement.setAttribute('aria-hidden', 'false');
      this.statusElement.textContent = statusText;

      setTimeout(() => {
        this.statusElement.setAttribute('aria-hidden', 'true');
      }, 1000);
    }
  }

  renderSearchResults(resultsMarkup) {
    const results = document.createElement('div');
    results.innerHTML = resultsMarkup;
    results.classList.add('predictive-search--container');

    // search 3.0
    if (this.id == 'predictive-search__header') {
      results.classList.add('predictive-search-header__suggestions');
      this.classList.add('suggestions-shown');
      this.querySelector('.predictive-search--container')?.remove();
      this.appendChild(results);
    }
    else if (this.id == 'predictive-search_main') {
      const resultsEl = this.querySelector('#search-results');
      resultsEl.innerHTML = '';
      this.setAttribute('results', true);
      resultsEl.appendChild(results);
      this.setLiveRegionResults();
      initializeCustomTabs();

      this.updatePDPlink();
    }

  }

  renderSearchSuggestions(suggestionsMarkup) {
    const suggestions = document.createElement('div');
    suggestions.innerHTML = suggestionsMarkup;
    suggestions.classList.add('predictive-search--container', 'predictive-search-suggestions__container');
    const suggestionsTarget = this.querySelector('.predictive-search-results__items-results');

    this.querySelector('.predictive-search-suggestions__container')?.remove();
    if (suggestionsTarget) {
      suggestionsTarget.innerHTML = '';
      suggestionsTarget.appendChild(suggestions);
    } else {
      this.appendChild(suggestions);
    }
    this.classList.add('suggestions-shown');
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom - 20;
    if (window.innerWidth < 768) {
      this.resultsMaxHeight = window.innerHeight - 20;
    }
    return this.resultsMaxHeight;
  }

  open() {
    // this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;

    if (this.headerSearch) this.searchFilterModal.style.display = 'none' // Hide search landing popup
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;

    if (this.headerSearch) this.searchFilterModal.style.display = 'block' // Show search landing popup
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    // this.predictiveSearchResults.removeAttribute('style');
  }

  bindSearchFilterToInput() {
    const searchFilters = document.querySelectorAll('.search-filters__list');

    searchFilters.forEach((searchFilter) => {
      searchFilter.addEventListener('click', (event) => {
        const filterItem = event.target.closest('.search-filters__item');
        if (filterItem) {
          const currentTarget = event.target;
          this.handleFilterItemClick(currentTarget);
        }
      });
    });
  }

  handleFilterItemClick(currentTarget) {
    let filterItemText = currentTarget.textContent.trim();

    if (currentTarget.dataset.searchTerm) {
      filterItemText = currentTarget.dataset.searchTerm;
    }
    if (currentTarget.dataset.originalText) {
      filterItemText = currentTarget.dataset.originalText;
    }

    const newFilterItemText = filterItemText.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');

    let searchModalTarget = currentTarget.closest('.search-modal');
    let searchTarget = currentTarget.closest('predictive-search') || searchModalTarget;

    if (searchTarget) {
      let searchInput = searchTarget.querySelector('.search__input');

      searchInput.value = newFilterItemText;

      // Recent Searches - Update local storage & list
      // this.updateRecentSearches(newFilterItemText);

      let inputEvent = new CustomEvent('input', {
        bubbles: true,
        cancelable: true,
        detail: { source: 'search_button_filters' }
      });

      searchInput.dispatchEvent(inputEvent);

      // Hide Search Suggestions if a tag is clicked
      if (searchModalTarget) {
        const predictiveSearch = searchModalTarget.querySelector('predictive-search');
        if (predictiveSearch) {
          if (!predictiveSearch.classList.contains('search_suggestion_selected')) {
            predictiveSearch.classList.add('search_suggestion_selected');
          }
        }
      }

      // Scroll back to top
      searchTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }

  bindSearchSuggestionsToInput() {
    const searchModal = this.closest('.search-modal');

    if (searchModal) {
      const predictiveSearchSuggestions = this.querySelector('.predictive-search__suggestions');

      if (predictiveSearchSuggestions) {
        const searchSuggestions = predictiveSearchSuggestions.querySelectorAll('li a');

        if (searchSuggestions && searchSuggestions.length > 0) {
          searchSuggestions.forEach((searchSuggestion) => {
            searchSuggestion.addEventListener('click', (event) => {
              event.preventDefault();
              const currentTarget = event.currentTarget;
              const buttonLink = currentTarget.href;
              if (buttonLink.includes('/search')) {
                this.handleFilterItemClick(currentTarget);
                // Hide Search Suggestions if a tag is clicked
                if (!this.classList.contains('search_suggestion_selected')) {
                  this.classList.add('search_suggestion_selected');
                }
              } else {
                window.location.href = buttonLink;
              }
            });
          });
        }
      }
    }
  }

  initSuggestionsLogic() {
    // close sugestions when clicking anywhere else besidies it or input
    document.body.addEventListener('click', (e) => {
      if (e.target.closest('.search_input_field') && this.contains(e.target)) {
        this.updateSuggestionsVisibility();
      }
      else if (e.target.closest('.predictive-search__suggestions') || e.target.closest('.predictive-search-header__suggestions')) {
        const suggestionItem = e.target.closest('.predictive-search__item');
        if (!suggestionItem) return;

        e.preventDefault(); // suggestions can be <a href>, don't let them navigate natively
        const searchTerm = suggestionItem.dataset.searchTerm;
        this.classList.remove('suggestions-shown');

        if (e.target.closest('#predictive-search__header')) {
          if (window.location.href.includes('/search')) {
            this.getSearchResults(searchTerm);
          } else {
            window.location.href = this.getSearchPageUrl(searchTerm);
          }
        }
        else if (e.target.closest('#predictive-search_main')) {
          this.getSearchResults(searchTerm);
        }
      }
      else {
        this.classList.remove('suggestions-shown');
      }
    })
  }

  updatePDPlink() {
    //updates product card link so that from PDP user can return to search
    if (window.location.href.includes('/search')) {
      let links = document.querySelectorAll('#predictive-search-results-groups-wrapper a[data-link-to-product]')
      links.forEach(el => {
        if (!el.href.includes('back-to-search')) {
          el.href = `${el.href}&back-to-search=${this.input.value}`
        }
      })
    }
  }

  filterButtonFilters() {
    let popularFilters = document.querySelectorAll('.header__search .filters__popular-searches .search-filters__item');

    if (!popularFilters.length) return;

    let searchTerm = this.input.value;
    let hiddenNumber = 0;

    if (document.querySelector(".filters__popular-searches .no-res-text")) {
      document.querySelector(".filters__popular-searches .no-res-text").remove();
    }

    popularFilters.forEach(el => {
      const originalText = el.dataset.originalText || el.textContent;

      if (!searchTerm) {
        // Reset to original when input is empty
        el.innerHTML = originalText;
        el.style.display = "";
        hiddenNumber = 0;
        return;
      }

      if (originalText.toLowerCase().includes(searchTerm)) {
        const regex = new RegExp(`(${searchTerm})`, "gi");
        el.innerHTML = originalText.replace(regex, "<b>$1</b>");
        el.style.display = "";
        hiddenNumber--;
      } else {
        el.innerHTML = originalText;
        el.style.display = "none";
        hiddenNumber++;
      }
    });

    // check hidden
    if (hiddenNumber == popularFilters.length) {
      let noResText = document.createElement('p');
      noResText.innerHTML = `<p class="no-res-text">No existen búsquedas populares que contengan "${searchTerm}"...</p>`
      document.querySelector('.header__search .filters__popular-searches').appendChild(noResText)
    }
  }

}

customElements.define('predictive-search', PredictiveSearch);